var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.7 20.6",
    style: {
      enableBackground: "new 0 0 20.7 20.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E50056;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline",
    transform: "translate(-1.669 -1.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    className: "st0",
    d: "M15,1.6L3.6,13L8,17.4l8.2-8.2l-1.4-1.4L8,14.6L6.4,13L15,4.4L19.6,9L9.5,19.1l-5.2,0.7L5,17.2 l-1.7-1.6l-1.7,6.6l8.8-1.3L22.4,9L15,1.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.ceb4e219ea338e726ff3be0d552c5456.svg";
export { ForwardRef as ReactComponent };